import { InjectionToken } from '@angular/core';

export const MXV_APP_CONFIG = new InjectionToken<any>('MXV_APP_CONFIG');
